import FlowApp from './App';
import { BPC_BASE_PATH } from '../bpc/utils/constants';
import { BpcApp } from '../bpc/App';

export const IS_BPC_APP = window.location.pathname.startsWith(BPC_BASE_PATH);

export default IS_BPC_APP ? BpcApp : FlowApp;
